<template>
	<div class="map-controls" v-if="this.show === true">
		<ul>
			<li id="zoom-btn-plus" v-on:click="this.zoomIn" ref="zoom-btn-plus" role="button">
				+
			</li>
			<li id="zoom-btn-minus" v-on:click="this.zoomOut" ref="zoom-btn-minus" role="button">
				-
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: "MapControls",
		data: function() {
			return {
				sharedStore: window.store
			}
		},
		computed: {
			show: function() {
				return this.sharedStore.state.screen !== "external";
			}
		},
		mounted: function() {

		},
		methods: {
			zoomIn: function() {
				this.sharedStore.increaseMapZoom();
			},
			zoomOut: function() {
				this.sharedStore.decreaseMapZoom();
			}
		}
	};
</script>

<style scoped lang="scss">
	.map-controls {
		position: absolute;
		bottom: 150px;
		right: 0;
		padding: 50px;
	}

	ul {
		display: flex;
		flex-direction: column;

		li {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 25px;
			border: 8px solid white;
			height: 68px;
			width: 68px;
			border-radius: 68px;
			color: white;
			font-size: 3rem;
			font-weight: bold;
			cursor: pointer;
		}
	}
</style>
